import React from "react";
import { FontLibrary } from "../components/FontLibrary";

export default function Fonts() {
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <h1
        className="font-display text-2xl font-bold text-slate-900"
        data-testid="fonts-title"
      >
        Font Library
      </h1>
      <p className="text-sm text-slate-500 mt-1 mb-6">
        Manage custom fonts used across certificate templates and generated PDFs.
      </p>
      <FontLibrary />
    </div>
  );
}
